<app-in-app-page>
  <app-header title="Dashboard" class=""></app-header>

  <main class="in-app-main">
    <h3 class="h2 underscore dashboard-title">General Account Info</h3>

    <div class="dashboard-grid">
      <div class="dashboard-section dashboard-section_account-info">
        <app-client-info-section
          [clientProfileInfo]="clientProfileInfo"
          [primaryClientNumber]="primaryClientNumber"
          [isLoading]="isClientInfoLoading"
        ></app-client-info-section>
      </div>

      <div class="dashboard-section dashboard-section_sent">
        <h3 class="h2 underscore">Recent Faxes Sent</h3>
        <app-brief-fax-table
          [faxes]="outboundFaxes"
          [folders]="folders"
          [isLoading]="isOutboundFaxesLoading"
          placeholderText="No faxes sent"
          (rowClick)="navigateToFax($event)"
        ></app-brief-fax-table>
      </div>

      <div class="dashboard-section dashboard-section_received">
        <h3 class="h2 underscore">Recent Faxes Received</h3>
        <app-brief-fax-table
          [faxes]="inboundFaxes"
          [folders]="folders"
          [isLoading]="isInboundFaxesLoading"
          placeholderText="No faxes received"
          (rowClick)="navigateToFax($event)"
        ></app-brief-fax-table>
      </div>
    </div>
  </main>
</app-in-app-page>
